// Entrypoint for js-bundling: register jquery as global Var

import $ from "jquery";
globalThis.jQuery = $;
globalThis.$ = $;
